import { apiClient, ApiError, getAuthToken } from './client';
import { mapOrganisationEntitlementsDto } from './dtoMappers';
import { getErrorMessage } from './errors';
import type { OrganisationEntitlementsDto } from '@flowqa/shared';

const toApiError = (err: unknown): ApiError =>
  err instanceof ApiError ? err : new ApiError(getErrorMessage(err));

const ensureToken = (): string => {
  const token = getAuthToken();
  if (!token) {
    throw new ApiError('Not authenticated');
  }
  return token;
};

export const getOrganisationEntitlements = async (
  organisationId: string,
): Promise<OrganisationEntitlementsDto> => {
  const token = ensureToken();
  try {
    const result = await apiClient.get<OrganisationEntitlementsDto>(
      `organisations/${organisationId}/entitlements`,
      { retries: 1, token },
    );
    return mapOrganisationEntitlementsDto(result);
  } catch (err) {
    throw toApiError(err);
  }
};
